export class Auth {
    serverPath: string = 'https://pinsouqstore.com/wp-json/jwt-auth/v1/token';
}